import classNames from 'classnames/bind';
import styles from './v1Result.module.scss';

const cx = classNames.bind(styles);

const V1Result = () => {
  return (
    <div className={cx('emptyArea')}>
      2022년 3월 24일 이전 응시한 역검은
      <br />
      상세 결과표가 제공되지 않습니다.
    </div>
  );
};

export default V1Result;
